import React from 'react';
import { connect } from 'react-redux';
import * as actions from '../../../../../redux/testMode/actions.testMode';
import _ from 'lodash';
import TestModeBubbleEditor from '../TestModeBubbleEditor/TestModeBubbleEditor';
import ProgressLoader from '../../../../components/ProgressLoader/ProgressLoader';
import asyncDispatch from '../../../../../services/mini/asyncDispatch';
import getNodeKey from '../../../../../services/mini/getKeyNode';
import getConversationId from '../../../../../services/mini/getConversationId';
import DialogItemHolder from './DialogItemHolder';

class Dialog extends React.Component {
    constructor(props, context) {
        super(props, context);

        const { dialog, refreshingDialogs } = props;

        this.state = {
            refreshing: !!refreshingDialogs[dialog[0].id]
        };
    }

    componentDidMount() {
        const { dialog, project, environment, connectTestCases } = this.props;
        if (project && environment) {
            connectTestCases({
                projectId: project.projectId,
                environment,
                node: dialog[0]
            });
        }
    }

    componentDidUpdate(prevProps, prevState) {
        const { dialog, refreshingDialogs, project, environment, connectTestCases } = this.props;
        if (refreshingDialogs[dialog[0].id] !== prevProps.refreshingDialogs[dialog[0].id]) {
            this.setState({ refreshing: !!refreshingDialogs[dialog[0].id] });
        }
        if (prevProps.environment !== environment) {
            connectTestCases({ projectId: project.projectId, environment, node: dialog[0] });
        }
    }

    componentWillUnmount() {
        const { dialog } = this.props;
        this.props.disconnectTestCases({ node: dialog[0] });
    }

    copyDialog = () => {
        const { dialog, conversationId, copyDialog, dialogTree } = this.props;
        copyDialog({
            conversationId,
            node: dialog[0],
            dialogTree
        });
    }

    refreshDialog = () => {
        const { dialog, conversationId, refreshPhrases, dialogTree } = this.props;
        this.setState({ refreshing: true });
        refreshPhrases({
            conversationId,
            node: dialog[0],
            dialogTree,
            resetDialogContext: true,
        });
    }

    deleteDialog = () => {
        const { dialog, conversationId, deleteDialog, dialogTree } = this.props;
        deleteDialog({
            conversationId,
            node: dialog[0],
            dialogTree,
        });
    }

    render() {
        const {
            index,
            dialog,
            activeDialogIdForQrCode,
            activeDialogConnectedByQrCode,
            dialogTree,
            isDialogsRefreshingInProcess,
            isOneDialogRefreshingInProcess,
            actualDialogId,
            refreshingDialogs,
            refreshingIsInProcess
        } = this.props;

        const { refreshing } = this.state;

        let { count: all, updated } = refreshingDialogs[dialog[0]?.id] || {};

        updated = updated ? Object.keys(updated).length : 0;

        const dialogs = dialogTree.toDialogs({}, 0);
        const dialogCount = Object.keys(dialogs).length;
        let title = '';
        let qrCodeTitle;
        const isActual = actualDialogId === dialog[0]?.id;
        const passed = dialog[0]?.isPassedRecursively();
        const connectedByQrCode = dialog[0]?.id === activeDialogIdForQrCode && activeDialogConnectedByQrCode;
        if (passed === true) {
            title = 'Dialog is passed';
        } else if (passed === false) {
            if (dialog[0]?.isPassedRecursively() === false) {
                title += 'There are failed phrases in the dialog.';
            }
        }

        if (connectedByQrCode) {
            qrCodeTitle = 'There is an application that is connected by QR-code to this dialog.';
        }

        const isCopyDisabled = !dialog[0].hasFilledResuest();

        return (
            <div
                className={`dialog ${(refreshing || isDialogsRefreshingInProcess || isOneDialogRefreshingInProcess || refreshingIsInProcess) && 'refreshing'} ${!isActual && 'outdated'}`}>
                <div className={`dialog__refresh-progress-holder ${refreshing && 'refreshing'}`}>
                    <div className="dialog__refresh-progress">
                        {all ? updated + "/" + all : ""}
                    </div>
                </div>
                <div className="dialog__header">
                    <div className="dialog__name">
                        {passed === false && <i className="icon icon-alan-test-error" title={title} />}
                        {passed === true && <i className="icon icon-alan-test-check" title={title} />}
                        {connectedByQrCode && <i className="icon icon-alan-test-qr" title={qrCodeTitle} />}
                        {`Dialog ${index + 1}`}
                    </div>

                    <div className="dialog__dragger">
                        <i className="icon icon-alan-test-dots" />
                    </div>
                    <div className="dialog__actions">
                        <i className="icon icon-alan-test-play"
                            onClick={this.refreshDialog}
                            title="Refresh" />
                        <i className={`icon icon-alan-test-copy ${isCopyDisabled && 'disabled'}`}
                            onClick={this.copyDialog}
                            title="Copy" />
                        <i className={`icon icon-alan-test-delete ${dialogCount === 1 && 'disabled'}`}
                            onClick={this.deleteDialog}
                            title="Delete" />
                    </div>
                </div>
                <div className="dialog__body">
                    {dialog
                        .filter(node => node.request)
                        .map((node, index) => {
                            return <DialogItemHolder
                                key={getNodeKey(node)}
                                index={index}
                                node={node}
                                dialog={dialog}
                            />;
                        })}
                </div>
                <div className="dialog__footer">
                    <TestModeBubbleEditor
                        dialog={dialog}
                        index={index}
                        scrollToLastBubble={this.props.scrollToLastBubble}
                        autoFocus={dialog[0]?.request === undefined}
                        refreshDialog={this.refreshDialog}
                    />
                </div>
            </div>
        );
    }
}


function mapStateToProps({ testMode, projectsInfo }) {
    return {
        actualDialogId: testMode.actualDialogId,
        refreshingDialogs: testMode.refreshingDialogs,
        isDialogsRefreshingInProcess: testMode.isDialogsRefreshingInProcess,
        isOneDialogRefreshingInProcess: testMode.isOneDialogRefreshingInProcess,
        refreshingIsInProcess: testMode.refreshingIsInProcess,
        activeDialogIdForQrCode: testMode.activeDialogIdForQrCode,
        activeDialogConnectedByQrCode: testMode.activeDialogConnectedByQrCode,
        conversationId: getConversationId(projectsInfo.currentProject.conversations)
    };
}

function mapDispatchToProps(dispatch) {
    return {
        copyDialog: (param) => asyncDispatch(actions.copyDialog, dispatch, param),
        deleteDialog: (param) => dispatch(actions.deleteDialog(param)),
        refreshPhrases: (param) => asyncDispatch(actions.refreshPhrases, dispatch, param),
        connectTestCases: (param) => dispatch(actions.connectTestCases(param)),
        disconnectTestCases: (param) => dispatch(actions.disconnectTestCases(param)),

    };
}

export default connect(mapStateToProps, mapDispatchToProps)(Dialog);

